import { getEnvironment, isProduction } from '../../config/environment';
import { EnvironmentActionsTypes as types } from './actions';

const initialState = {
  environment: getEnvironment(),
  allowChangingEnvironment: !isProduction(),
};

export default function environmentReducer(state = initialState, action) {
  switch (action.type) {
    case types.ENVIRONMENT_CHANGE:
      return { ...state, environment: action.payload };
    default:
      return state;
  }
}
